import type { AppListenerMiddleware } from "@src/store/rootState";
import {
  removeExperienceProductIssuesSyncing,
  setExperienceProductIssues,
} from "@src/store/slices/experienceProductIssues/index";
import { selectedExperience } from "@src/store/slices/experiences";
import { sendWebsocketMessage } from "@src/store/slices/global";

export function setupExperienceProductIssuesListener(
  middleware: AppListenerMiddleware
) {
  middleware.startListening({
    actionCreator: sendWebsocketMessage,
    effect: (action, { dispatch, getState }) => {
      if (action.payload.type === "experienceProductIssues") {
        const { issues, processedIssueKeys } = action.payload;
        const experience = selectedExperience(getState());
        if (issues.experienceId === experience?.id) {
          dispatch(setExperienceProductIssues(issues));
          if (processedIssueKeys) {
            dispatch(removeExperienceProductIssuesSyncing(processedIssueKeys));
          }
        }
      }
    },
  });
}
